export default __webpack_public_path__ + "static/media/logo_nigel.a34cf91d.svg";